 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHTNOTICE from '@/components/xhtml/copyrightnotice'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLINTRO from '@/components/xhtml/intro'
 import XHTMLPART1 from '@/components/xhtml/part1'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLCHAPTER9 from '@/components/xhtml/chapter9'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/chapter12'
 import XHTMLCHAPTER13 from '@/components/xhtml/chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/chapter14'
 import XHTMLCHAPTER15 from '@/components/xhtml/chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/chapter16'
 import XHTMLCHAPTER17 from '@/components/xhtml/chapter17'
 import XHTMLCHAPTER18 from '@/components/xhtml/chapter18'
 import XHTMLCHAPTER19 from '@/components/xhtml/chapter19'
 import XHTMLCHAPTER20 from '@/components/xhtml/chapter20'
 import XHTMLCHAPTER21 from '@/components/xhtml/chapter21'
 import XHTMLCHAPTER22 from '@/components/xhtml/chapter22'
 import XHTMLCHAPTER23 from '@/components/xhtml/chapter23'
 import XHTMLCHAPTER24 from '@/components/xhtml/chapter24'
 import XHTMLCHAPTER25 from '@/components/xhtml/chapter25'
 import XHTMLCHAPTER26 from '@/components/xhtml/chapter26'
 import XHTMLCHAPTER27 from '@/components/xhtml/chapter27'
 import XHTMLCHAPTER28 from '@/components/xhtml/chapter28'
 import XHTMLCHAPTER29 from '@/components/xhtml/chapter29'
 import XHTMLCHAPTER31 from '@/components/xhtml/chapter31'
 import XHTMLPART2 from '@/components/xhtml/part2'
 import XHTMLCHAPTER33 from '@/components/xhtml/chapter33'
 import XHTMLCHAPTER34 from '@/components/xhtml/chapter34'
 import XHTMLCHAPTER35 from '@/components/xhtml/chapter35'
 import XHTMLCHAPTER36 from '@/components/xhtml/chapter36'
 import XHTMLCHAPTER37 from '@/components/xhtml/chapter37'
 import XHTMLCHAPTER38 from '@/components/xhtml/chapter38'
 import XHTMLCHAPTER39 from '@/components/xhtml/chapter39'
 import XHTMLCHAPTER40 from '@/components/xhtml/chapter40'
 import XHTMLCHAPTER41 from '@/components/xhtml/chapter41'
 import XHTMLCHAPTER42 from '@/components/xhtml/chapter42'
 import XHTMLCHAPTER43 from '@/components/xhtml/chapter43'
 import XHTMLCHAPTER44 from '@/components/xhtml/chapter44'
 import XHTMLCHAPTER45 from '@/components/xhtml/chapter45'
 import XHTMLCHAPTER46 from '@/components/xhtml/chapter46'
 import XHTMLCHAPTER47 from '@/components/xhtml/chapter47'
 import XHTMLCHAPTER48 from '@/components/xhtml/chapter48'
 import XHTMLCHAPTER49 from '@/components/xhtml/chapter49'
 import XHTMLCHAPTER50 from '@/components/xhtml/chapter50'
 import XHTMLCHAPTER51 from '@/components/xhtml/chapter51'
 import XHTMLCHAPTER52 from '@/components/xhtml/chapter52'
 import XHTMLPART3 from '@/components/xhtml/part3'
 import XHTMLCHAPTER53 from '@/components/xhtml/chapter53'
 import XHTMLCHAPTER54 from '@/components/xhtml/chapter54'
 import XHTMLCHAPTER55 from '@/components/xhtml/chapter55'
 import XHTMLCHAPTER56 from '@/components/xhtml/chapter56'
 import XHTMLCHAPTER57 from '@/components/xhtml/chapter57'
 import XHTMLCHAPTER58 from '@/components/xhtml/chapter58'
 import XHTMLCHAPTER59 from '@/components/xhtml/chapter59'
 import XHTMLCHAPTER60 from '@/components/xhtml/chapter60'
 import XHTMLCHAPTER61 from '@/components/xhtml/chapter61'
 import XHTMLCHAPTER62 from '@/components/xhtml/chapter62'
 import XHTMLCHAPTER63 from '@/components/xhtml/chapter63'
 import XHTMLCHAPTER64 from '@/components/xhtml/chapter64'
 import XHTMLCHAPTER65 from '@/components/xhtml/chapter65'
 import XHTMLCHAPTER66 from '@/components/xhtml/chapter66'
 import XHTMLCHAPTER67 from '@/components/xhtml/chapter67'
 import XHTMLCHAPTER68 from '@/components/xhtml/chapter68'
 import XHTMLCHAPTER69 from '@/components/xhtml/chapter69'
 import XHTMLCHAPTER70 from '@/components/xhtml/chapter70'
 import XHTMLCHAPTER71 from '@/components/xhtml/chapter71'
 import XHTMLCHAPTER72 from '@/components/xhtml/chapter72'
 import XHTMLCHAPTER73 from '@/components/xhtml/chapter73'
 import XHTMLCHAPTER74 from '@/components/xhtml/chapter74'
 import XHTMLCHAPTER75 from '@/components/xhtml/chapter75'
 import XHTMLCHAPTER76 from '@/components/xhtml/chapter76'
 import XHTMLCHAPTER77 from '@/components/xhtml/chapter77'
 import XHTMLCHAPTER78 from '@/components/xhtml/chapter78'
 import XHTMLCHAPTER79 from '@/components/xhtml/chapter79'
 import XHTMLCHAPTER80 from '@/components/xhtml/chapter80'
 import XHTMLCHAPTER81 from '@/components/xhtml/chapter81'
 import XHTMLCHAPTER82 from '@/components/xhtml/chapter82'
 import XHTMLCHAPTER83 from '@/components/xhtml/chapter83'
 import XHTMLCHAPTER84 from '@/components/xhtml/chapter84'
 import XHTMLCHAPTER85 from '@/components/xhtml/chapter85'
 import XHTMLCHAPTER86 from '@/components/xhtml/chapter86'
 import XHTMLCHAPTER87 from '@/components/xhtml/chapter87'
 import XHTMLCHAPTER88 from '@/components/xhtml/chapter88'
 import XHTMLCHAPTER89 from '@/components/xhtml/chapter89'
 import XHTMLCHAPTER90 from '@/components/xhtml/chapter90'
 import XHTMLCHAPTER91 from '@/components/xhtml/chapter91'
 import XHTMLCHAPTER92 from '@/components/xhtml/chapter92'
 import XHTMLCHAPTER93 from '@/components/xhtml/chapter93'
 import XHTMLCHAPTER94 from '@/components/xhtml/chapter94'
 import XHTMLCHAPTER95 from '@/components/xhtml/chapter95'
 import XHTMLCHAPTER96 from '@/components/xhtml/chapter96'
 import XHTMLCHAPTER97 from '@/components/xhtml/chapter97'
 import XHTMLCHAPTER98 from '@/components/xhtml/chapter98'
 import XHTMLCHAPTER99 from '@/components/xhtml/chapter99'
 import XHTMLCHAPTER100 from '@/components/xhtml/chapter100'
 import XHTMLCHAPTER101 from '@/components/xhtml/chapter101'
 import XHTMLCHAPTER102 from '@/components/xhtml/chapter102'
 import XHTMLCHAPTER103 from '@/components/xhtml/chapter103'
 import XHTMLCHAPTER104 from '@/components/xhtml/chapter104'
 import XHTMLCHAPTER105 from '@/components/xhtml/chapter105'
 import XHTMLCHAPTER106 from '@/components/xhtml/chapter106'
 import XHTMLCHAPTER107 from '@/components/xhtml/chapter107'
 import XHTMLCHAPTER108 from '@/components/xhtml/chapter108'
 import XHTMLCHAPTER109 from '@/components/xhtml/chapter109'
 import XHTMLCHAPTER110 from '@/components/xhtml/chapter110'
 import XHTMLCHAPTER111 from '@/components/xhtml/chapter111'
 import XHTMLCHAPTER112 from '@/components/xhtml/chapter112'
 import XHTMLCHAPTER113 from '@/components/xhtml/chapter113'
 import XHTMLCHAPTER114 from '@/components/xhtml/chapter114'
 import XHTMLCHAPTER115 from '@/components/xhtml/chapter115'
 import XHTMLCHAPTER116 from '@/components/xhtml/chapter116'
 import XHTMLCHAPTER117 from '@/components/xhtml/chapter117'
 import XHTMLCHAPTER118 from '@/components/xhtml/chapter118'
 import XHTMLCHAPTER119 from '@/components/xhtml/chapter119'
 import XHTMLCHAPTER120 from '@/components/xhtml/chapter120'
 import XHTMLCHAPTER121 from '@/components/xhtml/chapter121'
 import XHTMLCHAPTER122 from '@/components/xhtml/chapter122'
 import XHTMLCHAPTER123 from '@/components/xhtml/chapter123'
 import XHTMLCHAPTER124 from '@/components/xhtml/chapter124'
 import XHTMLCHAPTER125 from '@/components/xhtml/chapter125'
 import XHTMLCHAPTER126 from '@/components/xhtml/chapter126'
 import XHTMLCHAPTER127 from '@/components/xhtml/chapter127'
 import XHTMLCHAPTER128 from '@/components/xhtml/chapter128'
 import XHTMLCHAPTER129 from '@/components/xhtml/chapter129'
 import XHTMLCHAPTER130 from '@/components/xhtml/chapter130'
 import XHTMLCHAPTER131 from '@/components/xhtml/chapter131'
 import XHTMLCHAPTER132 from '@/components/xhtml/chapter132'
 import XHTMLCHAPTER133 from '@/components/xhtml/chapter133'
 import XHTMLCHAPTER134 from '@/components/xhtml/chapter134'
 import XHTMLCHAPTER135 from '@/components/xhtml/chapter135'
 import XHTMLCHAPTER136 from '@/components/xhtml/chapter136'
 import XHTMLCHAPTER137 from '@/components/xhtml/chapter137'
 import XHTMLCHAPTER138 from '@/components/xhtml/chapter138'
 import XHTMLCHAPTER139 from '@/components/xhtml/chapter139'
 import XHTMLCHAPTER140 from '@/components/xhtml/chapter140'
 import XHTMLCHAPTER141 from '@/components/xhtml/chapter141'
 import XHTMLPART4 from '@/components/xhtml/part4'
 import XHTMLCHAPTER142 from '@/components/xhtml/chapter142'
 import XHTMLCHAPTER143 from '@/components/xhtml/chapter143'
 import XHTMLCHAPTER144 from '@/components/xhtml/chapter144'
 import XHTMLCHAPTER145 from '@/components/xhtml/chapter145'
 import XHTMLCHAPTER146 from '@/components/xhtml/chapter146'
 import XHTMLCHAPTER147 from '@/components/xhtml/chapter147'
 import XHTMLCHAPTER148 from '@/components/xhtml/chapter148'
 import XHTMLCHAPTER149 from '@/components/xhtml/chapter149'
 import XHTMLCHAPTER150 from '@/components/xhtml/chapter150'
 import XHTMLCHAPTER151 from '@/components/xhtml/chapter151'
 import XHTMLCHAPTER152 from '@/components/xhtml/chapter152'
 import XHTMLCHAPTER153 from '@/components/xhtml/chapter153'
 import XHTMLCHAPTER154 from '@/components/xhtml/chapter154'
 import XHTMLCHAPTER155 from '@/components/xhtml/chapter155'
 import XHTMLCHAPTER156 from '@/components/xhtml/chapter156'
 import XHTMLCHAPTER157 from '@/components/xhtml/chapter157'
 import XHTMLCHAPTER158 from '@/components/xhtml/chapter158'
 import XHTMLCHAPTER159 from '@/components/xhtml/chapter159'
 import XHTMLCHAPTER160 from '@/components/xhtml/chapter160'
 import XHTMLCHAPTER161 from '@/components/xhtml/chapter161'
 import XHTMLCHAPTER162 from '@/components/xhtml/chapter162'
 import XHTMLCHAPTER163 from '@/components/xhtml/chapter163'
 import XHTMLCHAPTER165 from '@/components/xhtml/chapter165'
 import XHTMLCHAPTER166 from '@/components/xhtml/chapter166'
 import XHTMLCHAPTER167 from '@/components/xhtml/chapter167'
 import XHTMLCHAPTER168 from '@/components/xhtml/chapter168'
 import XHTMLCHAPTER169 from '@/components/xhtml/chapter169'
 import XHTMLCHAPTER170 from '@/components/xhtml/chapter170'
 import XHTMLCHAPTER171 from '@/components/xhtml/chapter171'
 import XHTMLCHAPTER172 from '@/components/xhtml/chapter172'
 import XHTMLCHAPTER173 from '@/components/xhtml/chapter173'
 import XHTMLCHAPTER174 from '@/components/xhtml/chapter174'
 import XHTMLCHAPTER175 from '@/components/xhtml/chapter175'
 import XHTMLCHAPTER176 from '@/components/xhtml/chapter176'
 import XHTMLCHAPTER177 from '@/components/xhtml/chapter177'
 import XHTMLCHAPTER178 from '@/components/xhtml/chapter178'
 import XHTMLCHAPTER178A from '@/components/xhtml/chapter178a'
 import XHTMLCHAPTER179 from '@/components/xhtml/chapter179'
 import XHTMLCHAPTER180 from '@/components/xhtml/chapter180'
 import XHTMLCHAPTER181 from '@/components/xhtml/chapter181'
 import XHTMLCHAPTER182 from '@/components/xhtml/chapter182'
 import XHTMLCHAPTER183 from '@/components/xhtml/chapter183'
 import XHTMLCHAPTER184 from '@/components/xhtml/chapter184'
 import XHTMLCHAPTER185 from '@/components/xhtml/chapter185'
 import XHTMLCHAPTER186 from '@/components/xhtml/chapter186'
 import XHTMLCHAPTER187 from '@/components/xhtml/chapter187'
 import XHTMLCHAPTER188 from '@/components/xhtml/chapter188'
 import XHTMLCHAPTER189 from '@/components/xhtml/chapter189'
 import XHTMLCHAPTER190 from '@/components/xhtml/chapter190'
 import XHTMLCHAPTER191 from '@/components/xhtml/chapter191'
 import XHTMLCHAPTER192 from '@/components/xhtml/chapter192'
 import XHTMLCHAPTER193 from '@/components/xhtml/chapter193'
 import XHTMLCHAPTER194 from '@/components/xhtml/chapter194'
 import XHTMLCHAPTER195 from '@/components/xhtml/chapter195'
 import XHTMLCHAPTER196 from '@/components/xhtml/chapter196'
 import XHTMLCHAPTER197 from '@/components/xhtml/chapter197'
 import XHTMLCHAPTER198 from '@/components/xhtml/chapter198'
 import XHTMLCHAPTER199 from '@/components/xhtml/chapter199'
 import XHTMLCHAPTER200 from '@/components/xhtml/chapter200'
 import XHTMLCHAPTER201 from '@/components/xhtml/chapter201'
 import XHTMLCHAPTER202 from '@/components/xhtml/chapter202'
 import XHTMLCHAPTER203 from '@/components/xhtml/chapter203'
 import XHTMLCHAPTER204 from '@/components/xhtml/chapter204'
 import XHTMLCHAPTER205 from '@/components/xhtml/chapter205'
 import XHTMLCHAPTER206 from '@/components/xhtml/chapter206'
 import XHTMLCHAPTER207 from '@/components/xhtml/chapter207'
 import XHTMLCHAPTER208 from '@/components/xhtml/chapter208'
 import XHTMLCHAPTER209 from '@/components/xhtml/chapter209'
 import XHTMLCHAPTER210 from '@/components/xhtml/chapter210'
 import XHTMLCHAPTER211 from '@/components/xhtml/chapter211'
 import XHTMLCHAPTER212 from '@/components/xhtml/chapter212'
 import XHTMLCHAPTER213 from '@/components/xhtml/chapter213'
 import XHTMLCHAPTER214 from '@/components/xhtml/chapter214'
 import XHTMLCHAPTER215 from '@/components/xhtml/chapter215'
 import XHTMLCHAPTER216 from '@/components/xhtml/chapter216'
 import XHTMLCHAPTER217 from '@/components/xhtml/chapter217'
 import XHTMLCHAPTER218 from '@/components/xhtml/chapter218'
 import XHTMLCHAPTER219 from '@/components/xhtml/chapter219'
 import XHTMLCHAPTER220 from '@/components/xhtml/chapter220'
 import XHTMLCHAPTER221 from '@/components/xhtml/chapter221'
 import XHTMLCHAPTER222 from '@/components/xhtml/chapter222'
 import XHTMLCHAPTER223 from '@/components/xhtml/chapter223'
 import XHTMLCHAPTER224 from '@/components/xhtml/chapter224'
 import XHTMLCHAPTER225 from '@/components/xhtml/chapter225'
 import XHTMLCHAPTER226 from '@/components/xhtml/chapter226'
 import XHTMLCHAPTER227 from '@/components/xhtml/chapter227'
 import XHTMLCHAPTER228 from '@/components/xhtml/chapter228'
 import XHTMLPART5 from '@/components/xhtml/part5'
 import XHTMLCHAPTER229 from '@/components/xhtml/chapter229'
 import XHTMLCHAPTER230 from '@/components/xhtml/chapter230'
 import XHTMLCHAPTER231 from '@/components/xhtml/chapter231'
 import XHTMLCHAPTER232 from '@/components/xhtml/chapter232'
 import XHTMLCHAPTER233 from '@/components/xhtml/chapter233'
 import XHTMLCHAPTER234 from '@/components/xhtml/chapter234'
 import XHTMLCHAPTER235 from '@/components/xhtml/chapter235'
 import XHTMLCHAPTER236 from '@/components/xhtml/chapter236'
 import XHTMLCHAPTER237 from '@/components/xhtml/chapter237'
 import XHTMLCHAPTER238 from '@/components/xhtml/chapter238'
 import XHTMLCHAPTER239 from '@/components/xhtml/chapter239'
 import XHTMLCHAPTER240 from '@/components/xhtml/chapter240'
 import XHTMLCHAPTER241 from '@/components/xhtml/chapter241'
 import XHTMLCHAPTER242 from '@/components/xhtml/chapter242'
 import XHTMLCHAPTER243 from '@/components/xhtml/chapter243'
 import XHTMLCHAPTER244 from '@/components/xhtml/chapter244'
 import XHTMLCHAPTER245 from '@/components/xhtml/chapter245'
 import XHTMLCHAPTER246 from '@/components/xhtml/chapter246'
 import XHTMLCHAPTER247 from '@/components/xhtml/chapter247'
 import XHTMLCHAPTER248 from '@/components/xhtml/chapter248'
 import XHTMLCHAPTER249 from '@/components/xhtml/chapter249'
 import XHTMLCHAPTER251 from '@/components/xhtml/chapter251'
 import XHTMLCHAPTER252 from '@/components/xhtml/chapter252'
 import XHTMLCHAPTER253 from '@/components/xhtml/chapter253'
 import XHTMLCHAPTER254 from '@/components/xhtml/chapter254'
 import XHTMLCHAPTER255 from '@/components/xhtml/chapter255'
 import XHTMLCHAPTER256 from '@/components/xhtml/chapter256'
 import XHTMLCHAPTER257 from '@/components/xhtml/chapter257'
 import XHTMLCHAPTER258 from '@/components/xhtml/chapter258'
 import XHTMLCHAPTER259 from '@/components/xhtml/chapter259'
 import XHTMLCHAPTER260 from '@/components/xhtml/chapter260'
 import XHTMLCHAPTER261 from '@/components/xhtml/chapter261'
 import XHTMLCHAPTER262 from '@/components/xhtml/chapter262'
 import XHTMLCHAPTER263 from '@/components/xhtml/chapter263'
 import XHTMLCHAPTER264 from '@/components/xhtml/chapter264'
 import XHTMLCHAPTER265 from '@/components/xhtml/chapter265'
 import XHTMLCHAPTER266 from '@/components/xhtml/chapter266'
 import XHTMLCHAPTER267 from '@/components/xhtml/chapter267'
 import XHTMLCHAPTER268 from '@/components/xhtml/chapter268'
 import XHTMLCHAPTER269 from '@/components/xhtml/chapter269'
 import XHTMLCHAPTER270 from '@/components/xhtml/chapter270'
 import XHTMLCHAPTER271 from '@/components/xhtml/chapter271'
 import XHTMLCHAPTER272 from '@/components/xhtml/chapter272'
 import XHTMLCHAPTER273 from '@/components/xhtml/chapter273'
 import XHTMLCHAPTER274 from '@/components/xhtml/chapter274'
 import XHTMLCHAPTER275 from '@/components/xhtml/chapter275'
 import XHTMLCHAPTER276 from '@/components/xhtml/chapter276'
 import XHTMLCHAPTER277 from '@/components/xhtml/chapter277'
 import XHTMLCHAPTER278 from '@/components/xhtml/chapter278'
 import XHTMLCHAPTER279 from '@/components/xhtml/chapter279'
 import XHTMLCHAPTER280 from '@/components/xhtml/chapter280'
 import XHTMLCHAPTER281 from '@/components/xhtml/chapter281'
 import XHTMLCHAPTER282 from '@/components/xhtml/chapter282'
 import XHTMLCHAPTER283 from '@/components/xhtml/chapter283'
 import XHTMLCHAPTER284 from '@/components/xhtml/chapter284'
 import XHTMLCHAPTER285 from '@/components/xhtml/chapter285'
 import XHTMLCHAPTER286 from '@/components/xhtml/chapter286'
 import XHTMLCHAPTER287 from '@/components/xhtml/chapter287'
 import XHTMLCHAPTER288 from '@/components/xhtml/chapter288'
 import XHTMLCHAPTER289 from '@/components/xhtml/chapter289'
 import XHTMLCHAPTER290 from '@/components/xhtml/chapter290'
 import XHTMLCHAPTER291 from '@/components/xhtml/chapter291'
 import XHTMLCHAPTER292 from '@/components/xhtml/chapter292'
 import XHTMLCHAPTER293 from '@/components/xhtml/chapter293'
 import XHTMLCHAPTER294 from '@/components/xhtml/chapter294'
 import XHTMLCHAPTER295 from '@/components/xhtml/chapter295'
 import XHTMLCHAPTER296 from '@/components/xhtml/chapter296'
 import XHTMLCHAPTER297 from '@/components/xhtml/chapter297'
 import XHTMLCHAPTER298 from '@/components/xhtml/chapter298'
 import XHTMLCHAPTER299 from '@/components/xhtml/chapter299'
 import XHTMLCHAPTER300 from '@/components/xhtml/chapter300'
 import XHTMLCHAPTER301 from '@/components/xhtml/chapter301'
 import XHTMLCHAPTER302 from '@/components/xhtml/chapter302'
 import XHTMLCHAPTER303 from '@/components/xhtml/chapter303'
 import XHTMLCHAPTER304 from '@/components/xhtml/chapter304'
 import XHTMLCHAPTER305 from '@/components/xhtml/chapter305'
 import XHTMLCHAPTER306 from '@/components/xhtml/chapter306'
 import XHTMLCHAPTER307 from '@/components/xhtml/chapter307'
 import XHTMLCHAPTER308 from '@/components/xhtml/chapter308'
 import XHTMLCHAPTER309 from '@/components/xhtml/chapter309'
 import XHTMLCHAPTER310 from '@/components/xhtml/chapter310'
 import XHTMLCHAPTER311 from '@/components/xhtml/chapter311'
 import XHTMLCHAPTER312 from '@/components/xhtml/chapter312'
 import XHTMLCHAPTER313 from '@/components/xhtml/chapter313'
 import XHTMLCHAPTER314 from '@/components/xhtml/chapter314'
 import XHTMLCHAPTER315 from '@/components/xhtml/chapter315'
 import XHTMLCHAPTER316 from '@/components/xhtml/chapter316'
 import XHTMLCHAPTER317 from '@/components/xhtml/chapter317'
 import XHTMLCHAPTER318 from '@/components/xhtml/chapter318'
 import XHTMLCHAPTER319 from '@/components/xhtml/chapter319'
 import XHTMLCHAPTER320 from '@/components/xhtml/chapter320'
 import XHTMLCHAPTER321 from '@/components/xhtml/chapter321'
 import XHTMLCHAPTER322 from '@/components/xhtml/chapter322'
 import XHTMLCHAPTER323 from '@/components/xhtml/chapter323'
 import XHTMLCHAPTER324 from '@/components/xhtml/chapter324'
 import XHTMLCHAPTER325 from '@/components/xhtml/chapter325'
 import XHTMLCHAPTER326 from '@/components/xhtml/chapter326'
 import XHTMLCHAPTER327 from '@/components/xhtml/chapter327'
 import XHTMLCHAPTER328 from '@/components/xhtml/chapter328'
 import XHTMLCHAPTER329 from '@/components/xhtml/chapter329'
 import XHTMLCHAPTER330 from '@/components/xhtml/chapter330'
 import XHTMLCHAPTER331 from '@/components/xhtml/chapter331'
 import XHTMLCHAPTER332 from '@/components/xhtml/chapter332'
 import XHTMLCHAPTER333 from '@/components/xhtml/chapter333'
 import XHTMLCHAPTER334 from '@/components/xhtml/chapter334'
 import XHTMLCHAPTER335 from '@/components/xhtml/chapter335'
 import XHTMLCHAPTER336 from '@/components/xhtml/chapter336'
 import XHTMLCHAPTER337 from '@/components/xhtml/chapter337'
 import XHTMLCHAPTER338 from '@/components/xhtml/chapter338'
 import XHTMLCHAPTER339 from '@/components/xhtml/chapter339'
 import XHTMLCHAPTER340 from '@/components/xhtml/chapter340'
 import XHTMLCHAPTER341 from '@/components/xhtml/chapter341'
 import XHTMLCHAPTER342 from '@/components/xhtml/chapter342'
 import XHTMLCHAPTER343 from '@/components/xhtml/chapter343'
 import XHTMLCHAPTER344 from '@/components/xhtml/chapter344'
 import XHTMLCHAPTER345 from '@/components/xhtml/chapter345'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLNOTE from '@/components/xhtml/note'
 import XHTMLKEYTERM from '@/components/xhtml/keyterm'
 import XHTMLWOMEN from '@/components/xhtml/women'
 import XHTMLFIND1 from '@/components/xhtml/find1'
 import XHTMLFIND2 from '@/components/xhtml/find2'
 import XHTMLREAD from '@/components/xhtml/read'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLADCARD from '@/components/xhtml/adcard'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/intro",
 			"name" : "xhtml/intro",
 			"component" : XHTMLINTRO
 		},
 		{
 			"path" : "/xhtml/part1",
 			"name" : "xhtml/part1",
 			"component" : XHTMLPART1
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/chapter2",
 			"name" : "xhtml/chapter2",
 			"component" : XHTMLCHAPTER2
 		},
 		{
 			"path" : "/xhtml/chapter3",
 			"name" : "xhtml/chapter3",
 			"component" : XHTMLCHAPTER3
 		},
 		{
 			"path" : "/xhtml/chapter4",
 			"name" : "xhtml/chapter4",
 			"component" : XHTMLCHAPTER4
 		},
 		{
 			"path" : "/xhtml/chapter5",
 			"name" : "xhtml/chapter5",
 			"component" : XHTMLCHAPTER5
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js